import { render, staticRenderFns } from "./Contact-Details.vue?vue&type=template&id=2906bb7b&scoped=true"
import script from "./Contact-Details.vue?vue&type=script&lang=js"
export * from "./Contact-Details.vue?vue&type=script&lang=js"
import style0 from "./Contact-Details.vue?vue&type=style&index=0&id=2906bb7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2906bb7b",
  null
  
)

export default component.exports